import React from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { Spinner } from 'js/social/shared/CreateSocialItem/Spinner';
import { AiButtonType } from 'js/social/shared/types';
import { TypeWriter } from './TypeWriter';
import _SummaryContainer from "AiSummary-SummaryContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AiSummary.tsx?styleId=SummaryContainer";
import _SummaryHeader from "AiSummary-SummaryHeader.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AiSummary.tsx?styleId=SummaryHeader";
import _SummaryHeaderText from "AiSummary-SummaryHeaderText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AiSummary.tsx?styleId=SummaryHeaderText";
import _LoadingContainer from "AiSummary-LoadingContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AiSummary.tsx?styleId=LoadingContainer";


const SummaryContainer = /*#__PURE__*/styled("div", null, {
  displayName: "SummaryContainer",
  styles: _SummaryContainer
});

const SummaryHeader = /*#__PURE__*/styled("div", null, {
  displayName: "SummaryHeader",
  styles: _SummaryHeader
});

const SummaryHeaderText = /*#__PURE__*/styled(Body, null, {
  displayName: "SummaryHeaderText",
  styles: _SummaryHeaderText
});

const LoadingContainer = /*#__PURE__*/styled("div", null, {
  displayName: "LoadingContainer",
  styles: _LoadingContainer
});

type AiSummaryProps = {
  type: AiButtonType;
  loading: boolean;
  summary?: string;
};

export const AiSummary: React.FC<AiSummaryProps> = ({
  type,
  loading,
  summary,
}) => {
  if (!loading && !summary) return null;

  return (
    <SummaryContainer type={type}>
      <SummaryHeader>
        <SummaryHeaderText size="md">Explain this {type}</SummaryHeaderText>
        <Body size="sm">Generated by AI</Body>
      </SummaryHeader>
      <Body size="sm">
        {loading || !summary ? (
          <LoadingContainer>
            <Spinner />
          </LoadingContainer>
        ) : (
          <TypeWriter presetHeight text={summary} speed={30} />
        )}
      </Body>
    </SummaryContainer>
  );
};
